import React, { useState } from 'react'
import {useAuth} from '../../state/auth.state'
import './cart.component.css'
import {useApp, useAppState} from '../../state/app.state'
import { useRouter } from '../../state/route.state'
import {FiShoppingCart} from 'react-icons/fi'
import useTranlation from '../../translation/hook'

export default function CartContainer(props){
    const {state: appState, methods:appMethods} = useAppState()
    const {methods} = useAuth()
    const t = useTranlation()
    const m = useRouter()
    
    const item = appMethods.getItem()
    
    const price = appMethods.calculatePrice(item) / 100
            // <div className="cost-container"> <span  >Totale: {appMethods.calculatePrice()}</span></div>
    console.log("price is : ", price)
    return (
        <div className="cart-container">
            <div className="button">{t("site_pages_shop_app_price_button")}: € {price}</div>
            <button className="button" onClick={() => m.methods.changeRoute("login")}><FiShoppingCart  /><span style={{marginLeft: 10}} >{t("site_pages_shop_app_payment_button")}</span></button>
        </div>
    )
}